export default __webpack_public_path__ + "static/media/ic_clock.56e9487b.svg";